import {css} from 'lit';
export const styles = css`:host {
  display: block;
  flex: 1 1 auto;
  text-align: center;
  font-size: 0.86em;
}

.fill {
  width: 100%;
  min-height: 50px;
  min-width: 100px;
  margin-bottom: 4px;
}

.name {
  font-weight: bold;
  color: var(--gray-700);
}

[title] {
  cursor: help;
  border-bottom: 1px dashed var(--gray-700);
}
`;
export default styles;
